import './Inter/inter.css'; // Font styles

const variables = {
  colorPrimaryMain: '#075BAA',
  colorTextPrimary: '#15181d',
  colorTextSecondary: '#636870',
  colorTextDisabled: '#a6abb2',
  colorNeutralMain: '#074eb8',
  colorPrimaryDark: '#043562',
  colorPrimaryLight: '#00b37d4d',
  colorNeutralDark: '#c9ccd1',
  colorErrorMain: '#dd1d00',
  colorErrorLight: '#fff4f0',
  colorBackgroundLight: '#f9f9fa',
  colorSuccessMain: '#008442',
  colorDarkGray: '#404040',
  colorSecondaryLight: '#3b3b3b',
  colorPurpleLight: '#f7e5ff',
  colorSuccessBg: '#e9ffd7',
  colorIconPrimary: '#312c2c',
  colorErrorDark: '#ffe6e6',
  colorGreen90: '#247F6A',
  colorWhite: '#fff',
  colorBorder: '#e6e7e9',
  colorFormInvalid: '#f65260',
  colorFormInvalidBorder: '#f75c',
  colorLinkBlue: '#2fa6f8',
  colorAsh80: '#00000014',
  colorButtonBackground: '#00b37d4d',

  fontFamily: 'Inter',
  fontH32: '600 32px/1.25 Inter, sans-serif',
  fontH24: '600 24px/1.25 Inter, sans-serif',
  fontH20: '600 20px/1.3 Inter, sans-serif',
  fontH14: '500 14px/1.5 Inter, sans-serif',
  fontH12: '500 12px/1.5 Inter, sans-serif',
  fontH16: '600 16px/1.38 Inter, sans-serif',
  fontH18: '600 18px/1.34 Inter, sans-serif',
  fontP18: '400 18px/1.5 Inter, sans-serif',
  fontP16: '400 16px/1.38 Inter, sans-serif',
  fontP14: '400 14px/1.43 Inter, sans-serif',
  fontP12: '400 12px/1.75 Inter, sans-serif',

  boxShadow: '0 0.25rem 1rem 0 rgba(0, 0, 0, 0.08)',
  logoHeight: '50px',
};

export default variables;
